import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-side-menu-group',
  standalone: true,
  imports: [ MatDividerModule ],
  templateUrl: './side-menu-group.component.html',
  styleUrl: './side-menu-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SideMenuGroupComponent {
  public hasDivider: InputSignal<boolean> = input(true);
}
